import { FunctionComponent } from "react";

interface BasicCardProps {
  children?: string | JSX.Element;
  icon?: JSX.Element;
  onClick?: () => any;
  className?: string;
}

const InfoCard: FunctionComponent<BasicCardProps> = ({
  children,
  icon,
  onClick,
  className = "",
}) => {
  return (
    <div
      className={`info-card card-primary ${
        onClick ? "card-hover" : ""
      } ${className}`}
      onClick={onClick}
    >
      {<div className={"info-icon-container"}>{icon ? icon : "?"}</div>}
      <div className={"info-content"}>{children}</div>
    </div>
  );
};

export default InfoCard;
